import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import TrustBadge from './TrustBadge';
import AuctionCountdown from './AuctionCountdown';

// 낙찰자 선택 화면 — 출품자 전용, pending_selection 상태에서만 표시
function AuctionWinnerSelection(props){
  var auctionId=props.auctionId;
  var onComplete=props.onComplete;

  var[top5,setTop5]=useState([]);
  var[meta,setMeta]=useState(null);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');
  var[confirming,setConfirming]=useState(null); // { action:'select'|'reject', bidId?, row? }
  var[submitting,setSubmitting]=useState(false);
  var[submitError,setSubmitError]=useState('');

  var loadTop5=function(){
    setLoading(true);
    setError('');
    authFetch(API+'/auctions/'+auctionId+'/top5')
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          setTop5(d.data.top5||[]);
          setMeta(d.data);
        }else{
          setError((d&&d.error)||'상위 입찰자 조회 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setLoading(false)});
  };

  useEffect(function(){
    loadTop5();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auctionId]);

  var askSelect=function(row){
    setSubmitError('');
    setConfirming({action:'select',bidId:row.bidId,row:row});
  };

  var askReject=function(){
    setSubmitError('');
    setConfirming({action:'reject'});
  };

  var cancelConfirm=function(){
    if(submitting)return;
    setConfirming(null);
    setSubmitError('');
  };

  var doAction=function(){
    if(submitting||!confirming)return;
    setSubmitting(true);
    setSubmitError('');
    var url=API+'/auctions/'+auctionId+'/'+(confirming.action==='select'?'select-winner':'reject-all');
    var body=confirming.action==='select'?JSON.stringify({bidId:confirming.bidId}):JSON.stringify({});
    authFetch(url,{method:'POST',body:body})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          setConfirming(null);
          if(onComplete)onComplete(d.data);
        }else{
          // 409 (이미 처리됨): 자동 리페치 유도
          var msg=(d&&d.error)||'처리 실패';
          if(d&&/이미 처리된/.test(msg)){
            setConfirming(null);
            if(onComplete)onComplete();
            return;
          }
          setSubmitError(msg);
        }
      })
      .catch(function(){setSubmitError('서버 연결 실패')})
      .then(function(){setSubmitting(false)});
  };

  // ────────── 렌더 ──────────
  if(loading){
    return (
      <div style={{padding:20,margin:'16px 20px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,textAlign:'center',color:'#94a3b8',fontSize:13}}>
        상위 입찰자 불러오는 중...
      </div>
    );
  }

  if(error){
    return (
      <div style={{padding:14,margin:'16px 20px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:12,color:'#dc2626',fontSize:13}}>
        ⚠ {error}
      </div>
    );
  }

  var deadlineRemaining=meta&&meta.deadlineRemaining;

  var formatMan=function(won){return Math.round(won/10000).toLocaleString()};

  var rankIcon=function(rank){
    if(rank===1)return '🥇';
    if(rank===2)return '🥈';
    if(rank===3)return '🥉';
    return String(rank);
  };

  var rankColor=function(rank){
    if(rank===1)return '#fbbf24';
    if(rank===2)return '#94a3b8';
    if(rank===3)return '#b45309';
    return '#cbd5e1';
  };

  return (
    <div style={{margin:'12px 16px'}}>
      {/* 헤더 카드 */}
      <div style={{padding:'16px 18px',background:'linear-gradient(135deg,#1B3A5C 0%,#334155 100%)',color:'#fff',borderRadius:12,marginBottom:12,boxShadow:'0 4px 16px rgba(27,58,92,0.25)'}}>
        <div style={{fontSize:16,fontWeight:800,display:'flex',alignItems:'center',gap:8}}>
          <span>🏆</span><span>낙찰자를 선택해주세요</span>
        </div>
        <div style={{fontSize:11,color:'rgba(255,255,255,0.8)',marginTop:6,lineHeight:1.5}}>
          24시간 내 선택하지 않으면 자동 만료되며 신뢰도 페널티가 부과됩니다
        </div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:12,padding:'10px 12px',background:'rgba(255,255,255,0.12)',borderRadius:8}}>
          <div style={{fontSize:11,color:'rgba(255,255,255,0.85)',fontWeight:700}}>선택 마감까지</div>
          <div style={{color:'#fff'}}>
            <AuctionCountdown timeRemaining={deadlineRemaining} size="md" onExpired={function(){if(onComplete)onComplete()}}/>
          </div>
        </div>
      </div>

      {/* 입찰자 카드 목록 */}
      {top5.length===0?(
        <div style={{padding:'40px 20px',textAlign:'center',background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,color:'#94a3b8'}}>
          <div style={{fontSize:48,marginBottom:10,opacity:0.4}}>👥</div>
          <div style={{fontSize:13,fontWeight:700,color:'#64748b'}}>입찰자가 없습니다</div>
          <div style={{fontSize:11,marginTop:4}}>아래 버튼으로 경매를 종료할 수 있습니다</div>
        </div>
      ):(
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {top5.map(function(row){
            var isCancelWarning=row.cancelledCount>=3;
            return (
              <div key={row.bidId}
                style={{padding:'14px 16px',background:'#fff',border:'2px solid '+(row.rank===1?'#fbbf24':'#e5e7eb'),borderRadius:12,boxShadow:row.rank===1?'0 4px 12px rgba(251,191,36,0.15)':'none'}}>
                <div style={{display:'flex',alignItems:'flex-start',gap:12}}>
                  {/* 순위 */}
                  <div style={{flexShrink:0,width:42,height:42,borderRadius:'50%',background:rankColor(row.rank)+'22',border:'2px solid '+rankColor(row.rank),display:'flex',alignItems:'center',justifyContent:'center',fontSize:row.rank<=3?20:15,fontWeight:800,color:rankColor(row.rank)}}>
                    {rankIcon(row.rank)}
                  </div>

                  {/* 정보 */}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                      <div style={{fontSize:20,fontWeight:800,color:'#1B3A5C'}}>
                        {formatMan(row.amount)}<span style={{fontSize:13,marginLeft:2,fontWeight:700}}>만원</span>
                      </div>
                    </div>

                    <div style={{display:'flex',alignItems:'center',gap:8,marginTop:6,flexWrap:'wrap'}}>
                      {row.trustBadge&&<TrustBadge badge={row.trustBadge} size="sm"/>}
                      <span style={{fontSize:11,color:'#64748b'}}>거래 {row.totalBuys||0}건</span>
                      {row.avgScore>0&&<span style={{fontSize:11,color:'#64748b'}}>· 평점 ⭐ {Number(row.avgScore).toFixed(1)}</span>}
                      {isCancelWarning&&<span style={{fontSize:10,color:'#dc2626',fontWeight:700}}>⚠ 과거 취소 {row.cancelledCount}회</span>}
                    </div>

                    <div style={{fontSize:11,color:'#475569',marginTop:6,fontWeight:600}}>
                      {row.companyName||row.bidderName||'익명'}
                    </div>

                    {row.memo&&(
                      <div style={{marginTop:8,padding:'8px 10px',background:'#f8fafc',borderRadius:6,fontSize:11,color:'#475569',lineHeight:1.5,whiteSpace:'pre-wrap',wordBreak:'break-word',border:'1px solid #e2e8f0'}}>
                        <span style={{color:'#94a3b8',marginRight:4}}>💬</span>{row.memo}
                      </div>
                    )}

                    <button onClick={function(){askSelect(row)}} disabled={submitting}
                      style={{marginTop:10,width:'100%',padding:'10px 0',background:row.rank===1?'#1B3A5C':'#fff',color:row.rank===1?'#fff':'#1B3A5C',border:'2px solid #1B3A5C',borderRadius:8,fontSize:13,fontWeight:800,cursor:submitting?'wait':'pointer',transition:'all 0.15s'}}>
                      이 입찰자 선택
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* 전체 거절 */}
      <div style={{marginTop:14,padding:'14px 16px',background:'#fff',border:'1px dashed #cbd5e1',borderRadius:12}}>
        <div style={{fontSize:12,fontWeight:700,color:'#475569',marginBottom:6}}>⚠ 적합한 입찰자가 없나요?</div>
        <div style={{fontSize:11,color:'#94a3b8',lineHeight:1.6,marginBottom:10}}>
          전체 거절 시 경매가 종료되며 차량을 다시 출품해야 합니다.
        </div>
        <button onClick={askReject} disabled={submitting}
          style={{width:'100%',padding:'10px 0',background:'#fef2f2',color:'#dc2626',border:'1px solid #fecaca',borderRadius:8,fontSize:12,fontWeight:700,cursor:submitting?'wait':'pointer'}}>
          전체 거절하기
        </button>
      </div>

      {/* 확인 모달 */}
      {confirming&&(
        <div onClick={cancelConfirm}
          style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
          <div onClick={function(e){e.stopPropagation()}}
            style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:400,boxShadow:'0 20px 60px rgba(0,0,0,0.3)',padding:'22px 22px 18px'}}>
            <div style={{fontSize:17,fontWeight:800,color:confirming.action==='reject'?'#dc2626':'#1B3A5C',marginBottom:12,textAlign:'center'}}>
              {confirming.action==='select'?'🏆 낙찰자 선택 확인':'⚠ 전체 거절 확인'}
            </div>
            {confirming.action==='select'&&confirming.row&&(
              <div style={{padding:'12px',background:'#eff6ff',borderRadius:8,marginBottom:14,textAlign:'center'}}>
                <div style={{fontSize:22,fontWeight:800,color:'#1B3A5C'}}>
                  {formatMan(confirming.row.amount)}<span style={{fontSize:13,fontWeight:700,marginLeft:2}}>만원</span>
                </div>
                <div style={{fontSize:11,color:'#64748b',marginTop:4}}>
                  {confirming.row.companyName||confirming.row.bidderName||''}
                </div>
              </div>
            )}
            <div style={{fontSize:12,color:'#475569',lineHeight:1.6,marginBottom:14,textAlign:'center'}}>
              {confirming.action==='select'
                ?'이 입찰자를 낙찰자로 확정합니다. 이 작업은 되돌릴 수 없습니다.'
                :'모든 입찰을 거절하고 경매를 종료합니다. 재출품이 필요합니다.'}
            </div>
            {submitError&&(
              <div style={{padding:'8px 10px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:6,fontSize:11,color:'#dc2626',marginBottom:12}}>
                {submitError}
              </div>
            )}
            <div style={{display:'flex',gap:8}}>
              <button onClick={cancelConfirm} disabled={submitting}
                style={{flex:1,padding:'12px 0',background:'#f1f5f9',border:'1px solid #cbd5e1',borderRadius:8,fontSize:13,fontWeight:700,color:'#475569',cursor:submitting?'wait':'pointer'}}>
                취소
              </button>
              <button onClick={doAction} disabled={submitting}
                style={{flex:2,padding:'12px 0',background:submitting?'#94a3b8':confirming.action==='reject'?'#dc2626':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:800,cursor:submitting?'wait':'pointer'}}>
                {submitting?'처리 중...':confirming.action==='select'?'✓ 낙찰 확정':'✕ 전체 거절'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AuctionWinnerSelection;
